import { Grid } from '@mui/material';
import PricelistTimeline from './PricelistTimeline';

export const PricelistTimelineTab = () => {
    return (
        <Grid container style={{ overflowY: 'auto', overflowX: 'hidden' }} direction="column" spacing={2}>
            <Grid item xs={12}>
                <PricelistTimeline />
            </Grid>
        </Grid>
    );
};
